"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "knocked", {
  enumerable: true,
  get: function get() {
    return _knocked["default"];
  }
});
var _knocked = _interopRequireDefault(require("./knocked"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }